// extracted by mini-css-extract-plugin
module.exports = {"block":"price-block_block__1j_TE","title":"price-block_title__18Kfm","hint":"price-block_hint__1YIF0","range":"price-block_range__3khD8"};